"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4860],{

/***/ 64860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34427);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81663);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92734);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74237);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93359);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41464);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92021);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96528);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60107);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19599);
/* harmony import */ var assets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57730);
/* harmony import */ var hooks_useCustomMediaQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83910);
/* harmony import */ var utility_baseURL__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(95877);











var LinkKit = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7108), __webpack_require__.e(8682)]).then(__webpack_require__.bind(__webpack_require__, 32079));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32079)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
});
var ImageKit = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79307));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79307)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
});
var ButtonKit = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.lazy(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6701), __webpack_require__.e(4923), __webpack_require__.e(5610)]).then(__webpack_require__.bind(__webpack_require__, 36551)).then(function(module) {
        return {
            default: module.ButtonKit
        };
    });
});
var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(theme) {
    return {
        wrapper: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            background: theme.palette.primary[200],
            borderRadius: theme.shape.medium,
            padding: "0 1.6rem",
            height: "12rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative"
        }, theme.breakpoints.between("xs", "sm"), {
            height: "29.1rem !important",
            padding: "0 1.6rem"
        }),
        btn: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            background: theme.palette.primary[700],
            color: theme.palette.primary.contrastText,
            borderRadius: theme.shape.medium,
            padding: "2rem 2.4rem"
        }, theme.breakpoints.between("xs", "sm"), {
            marginTop: "2.4rem"
        })
    };
});
var Wallet = function() {
    var theme = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var classes = useStyles();
    var isMobile = (0,hooks_useCustomMediaQuery__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
        container: true,
        className: classes.wrapper,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                md: 9,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    container: true,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            md: 3,
                            position: "relative",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, isMobile ? {
                                mt: isMobile ? "-8rem" : "-0.9rem",
                                ml: "-20%"
                            } : {
                                position: "absolute",
                                top: isMobile ? "-8rem" : "-6.8rem"
                            }), {
                                className: isMobile ? "element-center" : "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageKit, {
                                    src: assets__WEBPACK_IMPORTED_MODULE_3__/* .WalletImg */ .M9s,
                                    priority: true,
                                    objectFit: "cover",
                                    width: isMobile ? "170px" : "200px",
                                    height: isMobile ? "140px" : "159px"
                                })
                            }))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            md: 9,
                            mt: isMobile ? "1.6rem" : "0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    color: theme.palette.text.dark,
                                    variant: "h6",
                                    fontWeight: 700,
                                    lineHeight: "2.5rem",
                                    children: "اول کیف پول فعال کن، بعد خرید کن"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    variant: "subtitle1",
                                    color: theme.palette.text.secondary,
                                    fontWeight: 500,
                                    lineHeight: "2.1rem",
                                    style: {
                                        marginTop: "0.8rem"
                                    },
                                    textAlign: "justify",
                                    children: "با فعالسازی کیف پول های اعتباری کیپا و دریافت اعتبار، میتوانید از فروشگاه های زیر خرید کنید"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                md: 3,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    component: LinkKit,
                    href: (0,utility_baseURL__WEBPACK_IMPORTED_MODULE_13__/* .keepaApp */ .h4)(),
                    target: "_blank",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonKit, {
                            fullWidth: true,
                            className: classes.btn,
                            children: "مشاهده کیف پول ها و راهنمای خرید"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Wallet);


/***/ })

}]);